import { FC, Fragment } from 'react';

import Alert from '@mui/material/Alert';

import { AddFreeSpinsForm } from '../../form';

import { Select } from 'v2/components/select/Select';
import { DynabitGameFreeSpinInfoModel } from 'v2/types/FreeSpinModel';
import { formatNumber, identifyArrayToSelect } from 'v2/utils';

interface DynabitFreeSpinsParamProps {
  info: DynabitGameFreeSpinInfoModel;
  values: AddFreeSpinsForm;
  onLinesAmountChange: (v: number) => void;
}

export const DynabitFreeSpinsParam: FC<DynabitFreeSpinsParamProps> = ({ info, values, onLinesAmountChange }) => (
  <Fragment>
    <Select
      value={values.linesAmount ?? undefined}
      options={identifyArrayToSelect(info.availableLinesAmount)}
      label="Lines Amount"
      onChange={onLinesAmountChange}
      required
    />

    <Alert severity="info">
      Total bet = Bet x Lines Amount ({formatNumber(values.betSpins * (values.linesAmount ?? 1))})
    </Alert>
  </Fragment>
);
